import React, { useState, useEffect } from "react";
import { Download } from "lucide-react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const MyAccount = () => {
    const [isEditing, setIsEditing] = useState(false);

    const [articleData, setArticleData] = useState([]);
    const login = JSON.parse(localStorage.getItem("isLoggedIn")) || {};
    const [formData, setFormData] = useState({
        name: login.name || "",
        email: login.email || "",
        gender: login.gender || "",
        designation: login.designation || "",
        phone: login.mobile || "",
        country: login.country || "",
        address: login.address,
        city: login.city || "",
        state: login.state || "",
        pincode: login.pincode || "",
        mobile: login.mobile || "",
    });


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const toggleEdit = async () => {
        if (isEditing) {
            try {
                const response = await fetch("https://backend.impactjournal.co.in/register/update", {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(formData)
                });

                const result = await response.json();

                if (response.ok) {
                    toast.success("Details updated successfully!");
                    localStorage.setItem("isLoggedIn", JSON.stringify(result.user)); // Update local copy
                } else {
                    toast.error(result.message || "Failed to update details.");
                }
            } catch (err) {
                console.error("Update failed:", err);
                toast.error("Something went wrong while saving.");
            }
        }

        setIsEditing(!isEditing);
    };



    const handleDownload = (fileType, title) => {
        const filePath = `/path/to/files/${title}.${fileType}`;
        const link = document.createElement('a');
        link.href = filePath;
        link.download = `${title}.${fileType}`;
        link.click(); // Trigger download
    };

    useEffect(() => {
        const fetchUserArticles = async () => {
            if (!login.email) return;

            try {
                const res = await fetch(`https://backend.impactjournal.co.in/manuscript/user/${(login.user_id)}`);
                const data = await res.json();
                if (res.ok) {
                    setArticleData(data);
                } else {
                    toast.error("Failed to fetch article details");
                }
            } catch (err) {
                console.error("Fetch error:", err);
                toast.error("Server error while fetching articles");
            }
        };

        fetchUserArticles();
    }, [login.email]);

    return (
        <>
            {/* <ToastContainer position="top-center" autoClose={3000} /> */}
            <div className="account-container">
                <div className="account-card">
                    <h1 className="account-heading">My Account Details</h1>

                    {/* Personal Info */}
                    <div className="account-section">
                        <h2 className="account-subheading">Personal Information</h2>
                        <div className="account-grid">
                            {isEditing ? (
                                <>
                                    <div>
                                        <span>Name:</span>
                                        <input
                                            name="name"
                                            type="text"
                                            placeholder="Name"
                                            value={formData.name}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Email:</span>
                                        <input
                                            name="email"
                                            type="email"
                                            placeholder="Email"
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Gender:</span>
                                        <input
                                            name="gender"
                                            type="text"
                                            placeholder="Gender"
                                            value={formData.gender}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Designation:</span>
                                        <input
                                            name="designation"
                                            type="text"
                                            placeholder="Designation"
                                            value={formData.designation}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div><span>Name:</span> {formData.title} {formData.name}</div>
                                    <div><span>Email:</span> {formData.email}</div>
                                    <div><span>Gender:</span> {formData.gender}</div>
                                    <div><span>Designation:</span> {formData.designation}</div>
                                </>
                            )}
                        </div>
                    </div>

                    {/* Address Info */}
                    <div className="account-section">
                        <h2 className="account-subheading">Address Information</h2>
                        <div className="account-grid">
                            {isEditing ? (
                                <>
                                    <div>
                                        <span>Address:</span>
                                        <input
                                            name="address"
                                            type="text"
                                            placeholder="Address"
                                            value={formData.address}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>City:</span>
                                        <input
                                            name="city"
                                            type="text"
                                            placeholder="City"
                                            value={formData.city}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Pincode:</span>
                                        <input
                                            name="pincode"
                                            type="text"
                                            placeholder="Pincode"
                                            value={formData.pincode}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>State:</span>
                                        <input
                                            name="state"
                                            type="text"
                                            placeholder="State"
                                            value={formData.state}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Country:</span>
                                        <input
                                            name="country"
                                            type="text"
                                            placeholder="Country"
                                            value={formData.country}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div>
                                        <span>Mobile:</span>
                                        <input
                                            name="mobile"
                                            type="text"
                                            placeholder="Mobile"
                                            value={formData.mobile}
                                            onChange={handleChange}
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <div><span>Address:</span> {formData.address}</div>
                                    <div><span>City:</span> {formData.city}</div>
                                    <div><span>Pincode:</span> {formData.pincode}</div>
                                    <div><span>State:</span> {formData.state}</div>
                                    <div><span>Country:</span> {formData.country}</div>
                                    <div><span>Mobile:</span> {formData.mobile}</div>
                                </>
                            )}
                        </div>
                    </div>

                    <div className="account-button-wrapper">
                        <button className="account-edit-button" onClick={toggleEdit}>
                            {isEditing ? "Save Details" : "Edit Details"}
                        </button>
                    </div>
                </div>
            </div>
            <div className="account-container">
                <div className="account-card">
                    <h1 className="account-heading">My Articles Details</h1>
                    <div className="account-article-cards-container">
                        {articleData.map((article, index) => (
                            <div key={index} className="account-article-card-impact">
                                <div className="account-article-header-impact">
                                    <div className="account-article-ref-impact">
                                        Reference #: {article.referenceNumber}
                                    </div>
                                </div>

                                <div className="account-article-details-impact">
                                    <div className="article-account-title">
                                        <span>Title:</span> {article.articleTitle}
                                    </div>
                                    <div><span>Category:</span> {article.articleCategory}</div>
                                    <div>
                                        <span>Payment Status:</span>
                                        <span className={`account-article-badge-impact ${article.pay_status?.toLowerCase()}`}>
                                            {/* {article.paymentStatus} */}{article.pay_status}
                                        </span>
                                    </div>
                                    <div>
                                        <span>Article Status:</span>
                                        <span className={`account-article-badge-impact ${article.statusOptions?.toLowerCase()}`}>
                                            {article.statusOptions}
                                        </span>
                                    </div>
                                </div>

                                <div className="account-article-buttons-impact">
                                    {article.file && (
                                        <button
                                            className="account-article-btn-impact"
                                            onClick={() =>
                                                window.open(`https://backend.impactjournal.co.in/uploads/manuscripts/${article.file}`, "_blank")
                                            }
                                        >
                                            <Download size={16} 
                                            
                                            style={{ marginRight: '5px' }} 
                                            /> Article
                                        </button>
                                    )}

                                    {article.certificate && (
                                        <button
                                            className="account-article-btn-impact"
                                            onClick={() =>
                                                window.open(`https://backend.impactjournal.co.in/uploads/manuscripts/${article.certificate}`, "_blank")
                                            }
                                        >
                                            <Download size={16} style={{ marginRight: '5px' }} /> Certificate
                                        </button>
                                    )}
                                </div>
                            </div>
                        ))}

                    </div>
                </div>
            </div>
        </>
    );
};

export default MyAccount;
